export enum PreferenceTypes {
  JOB_PREFERENCES = 100,
  JOB_MATCH_NOTIFICATION = 200,
  NOTIFICATIONS = 250,
  UPDATE_PASSWORD = 300,
  FEEDBACK = 400,
  AUTO_SUBMISSION = 500,
}
